import { setDocuments } from "./documents";

export const setFieldValuesFunctions = {
  ...setDocuments,
};
